import { Alert, Button, CircularProgress } from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

// When a request fails, say so AND let the user try just that request again (instead of reloading the whole
// page). Two shapes, same behaviour:
//   <RetryNotice message onRetry />  - a full-width error with a Retry button: for a page's or a section's data.
//   <RetryInline message onRetry />  - the message with a small Retry link: for a card or a dropdown's helper text.
// `onRetry` re-runs only the failed request; the caller shows its own loading state while it runs.

export default function RetryNotice({ message, onRetry, sx }) {
  return (
    <Alert
      severity="error"
      sx={{ mb: 2, alignItems: 'center', ...sx }}
      action={
        onRetry && (
          <Button color="inherit" size="small" startIcon={<RefreshRoundedIcon />} onClick={onRetry}>
            Retry
          </Button>
        )
      }
    >
      {message || 'Could not load this'}
    </Alert>
  );
}

export function RetryInline({ message, onRetry, loading = false }) {
  return (
    <span>
      {message || 'Could not load'}{' '}
      {onRetry && (
        <Button
          size="small"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={12} /> : <RefreshRoundedIcon sx={{ fontSize: 14 }} />}
          onClick={(e) => {
            e.stopPropagation(); // inside a clickable card: retrying must not also open the card
            onRetry();
          }}
          sx={{ minWidth: 0, p: '0 6px', fontSize: 12, fontWeight: 700, textTransform: 'none', verticalAlign: 'baseline' }}
        >
          Retry
        </Button>
      )}
    </span>
  );
}
